<app-breadcrumb [title]="'Crypto'" [items]="['Dashboard']" [active_item]="'Crypto'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col-xxl-3 col-xl-4 box-col-4">
      <app-crypto-left-content></app-crypto-left-content>
    </div>
    <div class="col-xxl-6 col-xl-8 box-col-8e">
      <app-crypto-middle-content></app-crypto-middle-content>
    </div>
    <div class="col-xxl-3 box-col-12">
      <app-crypto-right-content></app-crypto-right-content>
    </div>
  </div>
</div>
